module.exports = __webpack_public_path__ + "static/media/solution1.e2a44ae2.png";